import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare global {
  interface Window { dataLayer: any[]; gtag: (...args: any[]) => void; }
}
@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  private measurementId = environment.firebase.measurementId;
  constructor() {
    this.init();
  }

  private init() {

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    const hostname = window.location.hostname;

    window.gtag('js', new Date());
    window.gtag('config', this.measurementId, {
      custom_map: { dimension1: 'sitio' },
      'cookie_flags': 'SameSite=None;Secure'
    });

    this.sendPageView(hostname);
  }

  public sendPageView(sitio: string) {
    window.gtag('event', 'page_view', {
      sitio,
    });
  }

  public sendCustomEvent(eventName: string, params: any) {
    window.gtag('event', eventName, params);
  }
}
